import { render, staticRenderFns } from "./delivery-store.vue?vue&type=template&id=89c5e5dc&scoped=true"
import script from "./delivery-store.vue?vue&type=script&lang=js"
export * from "./delivery-store.vue?vue&type=script&lang=js"
import style0 from "./delivery-store.vue?vue&type=style&index=0&id=89c5e5dc&prod&lang=scss&scoped=true"
import style1 from "./delivery-store.vue?vue&type=style&index=1&id=89c5e5dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c5e5dc",
  null
  
)

export default component.exports